import FEGOEditor from '@futuweb/fego-editor';

export const isMoo = () => {
    if (FEGOEditor) {
        const { app } = FEGOEditor;
        const { domain } = app.project.appInfo;
        return domain.indexOf('moomoo.com') > -1;
    }
    // FEGORender 下，通过域名是否带 moomoo.com 判断是否 moomoo 下
    return location.host.indexOf('moomoo.com') > -1;
};

export const getEntity = () => {
    return window._extra['tool-date-formatter']?.options?.entity;
};

/** 根据域名判断资讯链接是否是当前地区下的链接 */
export const isCurrentAreaUrl = (url) => {
    return isMoo() ? url.includes('moomoo.com') : url.includes('futunn.com');
};
